// =============================================================================
// GeneralPage.jsx — Resources → General (read-only, supervisor-authored)
// =============================================================================
// Content is authored under Manage → Resources Management (the "General" section);
// rendered here as a nestable tree of pages via the shared ResourceSection. (db-109)
// =============================================================================

import { ResourceSection } from "./ResourceSection.jsx";

export function GeneralPage() {
  return <ResourceSection section="general" heading="General" />;
}
